import {debounce} from 'lodash';
import * as React from 'react';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../../app/ApplicationContext';
import furoApi from '../../api/FuroApi';
import Config from '../../config';

import '../../client-details/ClientSelector.css';
import {BaseFormItemProps} from "./BaseFormItem";
import AutoCompleteFormItem from "./AutoCompleteFormItem";

interface Props extends BaseFormItemProps {
  validateOnDataSource?: boolean;
}

interface State {
  clientNames: string[];
}

class ClientNameAutoCompleteFormItem extends React.Component<Props, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  private readonly debouncedOnClientSearch: (value: string) => void;

  constructor(props: BaseFormItemProps) {
    super(props);

    this.state = {
      clientNames: [],
    };

    this.debouncedOnClientSearch = debounce(this.onClientSearch, Config.SEARCH_DEBOUNCE_TIMEOUT).bind(this);
  }

  public render(): React.ReactNode {
    const {validateOnDataSource} = this.props;
    const {clientNames} = this.state;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <AutoCompleteFormItem
          {...this.props}
          dataSource={clientNames}
          onChange={this.debouncedOnClientSearch}
          validateOnDataSource={validateOnDataSource}
        />
      </>
    );
  };

  private onClientSearch = (value: string) => {
    if (value.length < 3) {
      // Don't run search with therms shorter than 3 characters
      return;
    }

    const promise = furoApi.clients.getAll({
      page: 0,
      pageSize: 20,
      sortOrder: 'ascend',
      sortColumnKey: 'name',
      filters: {'name': [value]}
    }).then(response => {
      this.setState({clientNames: response.results.content.map(cs => cs.name),})
    });

    withLoadingOverlay(promise, this.loadingHandler);
  };

}

export default ClientNameAutoCompleteFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/ClientNameAutoCompleteFormItem.tsx